// extracted by mini-css-extract-plugin
export default {"employeeTitle":"ConfirmDeleteModal_employeeTitle__CRU2E","employeeLabel":"ConfirmDeleteModal_employeeLabel__gdMZL","employeeBtn":"ConfirmDeleteModal_employeeBtn__BqzAr"};